
<template>
      <div></div>
    </template>

<script>
      export default {
      created() {
          /** Connecteur A*/
          this.obj = {  
          'coA' : {
            'diametre' : {
              pkDiametre:1,
              typeDiametre: '900µ'
        }
        }};

        this.$store.commit('SET_CHOICE_COA', this.obj )
            }, 
                
      }
      </script>